export default __webpack_public_path__ + "static/media/breadcrumb.4632e68e.svg";